import type { ReactNode } from "react";
import { LocaleProvider } from "@itaas/core/i18n/LocaleContext";
import { TenantProvider } from "@itaas/core/tenant/TenantContext";
import { SubscriptionProvider } from "@itaas/core/subscription/SubscriptionContext";
import { HospitolAuthProvider } from "@/auth/PharmacyAuthProvider";

export function HospitolProviders({ children }: { children: ReactNode }) {
  return (
    <LocaleProvider>
      <HospitolAuthProvider>
        <TenantProvider>
          <SubscriptionProvider>{children}</SubscriptionProvider>
        </TenantProvider>
      </HospitolAuthProvider>
    </LocaleProvider>
  );
}

/** @deprecated */
export const PharmacyProviders = HospitolProviders;
